import { createContext, useContext } from 'react'

interface AssetBalance {
  uuid      : string,
  name    : string,
  amount  : number
}

export interface UserAccount {
  first_name?    : string,
  middle_name?   : string,
  last_name?     : string,
  street_number? : string,
  street_name?   : string,
  date_of_birth?  : string,
  city?           : string,
  country?      : string,
  postal_code?   : string,
  telephone?     : string,
  tax_residence? : string,
  username?      : string,
  email         : string,
  password?      : string,
  password_salt? : string,
  address?      : string,
  assets?       : AssetBalance[],
  logged_in?     : boolean,
  is_issuer     : boolean,
  is_investor    : boolean,
  is_employee    : boolean,
  is_pro_investor?: boolean
  kyc_submitted? : boolean,
  is_verified?   : boolean,
  confirm_password? : string,
  unique_code?    : string,
  name?           : string,
  description?   : string,
  web_site?       : string,
  timezone_value?  : string, 
  timezone_offset? : number,
}

export interface strUserInvestor {
  firstName    : string,
  middleName   : string,
  lastName     : string,
  streetNumber : string,
  streetName   : string,
  dateOfBirth  : string,
  city         : string,
  country      : string,
  postalCode   : string,
  telephone    : string,
  taxResidence : string,
  email        : string,
  password     : string
}

export interface strLoginInfo {
  username     : string,
  password     : string
}

export const defaultUserState: UserAccount = {
  email        : '',
  password     : '',
  logged_in    : false,
  is_issuer    : false,
  is_investor  : false,
  is_employee  : false,
  is_pro_investor: false,
  unique_code  : "",
  timezone_value : Intl.DateTimeFormat().resolvedOptions().timeZone,
  timezone_offset : 0
}

export const loginInfo: strLoginInfo = {
  username: "",
  password: ""
}

export const UserContext = createContext<UserAccount>(defaultUserState)
export const useUserContext = () => useContext(UserContext)